import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {darken} from 'polished'

const Button = ({id, label, backgroundColor, textColor, deactivated = false, width, buttonStyle = 'default', onClick}) => {
    let theme
    switch (buttonStyle) {
        case 'fullWidth':
            theme = fullWidthTheme
            break
        default:
            theme = defaultTheme
            break
    }

    return (
        <StyledButton
            type={'submit'}
            id={id}
            backgroundColor={backgroundColor}
            color={textColor}
            deactivated={deactivated}
            width={width}
            theme={theme}
            onClick={onClick && onClick}>
            {label}
        </StyledButton>
    )
}

Button.propTypes = {
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    deactivated: PropTypes.bool,
    onClick: PropTypes.func,
    width: PropTypes.number,
    buttonStyle: PropTypes.oneOf(['fullWidth', 'default']),
}

export default Button

const fullWidthTheme = {
    borderRadius: '5px',
    width: '100%',
    whiteSpace: 'wrap',
}

const defaultTheme = {
    borderRadius: '22px',
    width: '100%',
    whiteSpace: 'nowrap',
}

const StyledButton = styled.button`
        background-color: ${props => props.backgroundColor ? props.backgroundColor : 'grey'};
        border: none;
        color: ${props => props.color ? props.color : 'white'};
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        border-radius: ${props => props.theme.borderRadius};
        font-size: 18px;
        transition: width .3s ease, background-color .3s ease, box-shadow 0.1s ease-in-out;
        white-space: ${props => props.theme.whiteSpace};
        overflow: hidden;
        font-family: 'Open Sans', sans-serif !important;
        width: ${props => props.width ? props.width + 'px' : props.theme.width};
        cursor: pointer;
        &:focus{
           outline:0;
        }
        &:hover{
            background-color: ${props => props.backgroundColor ? darken(0.1, props.backgroundColor) : darken(0.1, 'grey')};
        }
        &:active {
            box-shadow: inset 0 2px 6px rgba(0,0,0,0.24), inset 0 2px 4px rgba(0,0,0,0.48);
            background-color: ${props => props.backgroundColor ? darken(0.2, props.backgroundColor) : darken(0.2, 'grey')};
        }
    `



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Button.jsx